import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-page-style-two',
  templateUrl: './services-page-style-two.component.html',
  styleUrls: ['./services-page-style-two.component.scss']
})
export class ServicesPageStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
